import Row from "../../../components/Row";
import { SummaryText } from "../../../utils/resellerPackageUtils";
import ViewPackages from "../../../components/packages/ViewPackages";

const BillableResellerSummary = ({ businessName, userFirstName, userLastName, userEmail, selectedPackages }) => {
	return (
		<div>
			<p>
				{SummaryText}
				<br />
				The Reseller will be able to assign training to their customers for the below packages.
			</p>
			<Row class="my-4">
				<div className="ap-col col-2">
					<h4 className="no-margin">Details</h4>
				</div>
				<div className="ap-col font_s">{businessName.value}</div>
				<div className="ap-col font_s">{userFirstName.value} {userLastName.value}<br />{userEmail.value}</div>
			</Row>
			<Row>
				<div className="ap-col col-2">
					<h4 className="no-margin">Packages</h4>
				</div>
			</Row>
			<div>
				<ViewPackages selectedPackages={selectedPackages} altTitle={null} />
			</div>
		</div>
	);
};

export default BillableResellerSummary;